import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const RESOURCES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('RESOURCES');
export const RESOURCES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	RESOURCES_CRUD_ACTION_CONSTANTS
);
